<template>
<div>
    <div class="container">
        <logo/>
        <div class="container text-center"><a href="/" @click.prevent="back()"><fa-icon :icon="['fal', 'chevron-left']"/> go back</a></div>
        <centered-card>
            <terms-conditions/>
            <a href="/" @click.prevent="back()"><fa-icon :icon="['fal', 'chevron-left']"/> go back</a>
        </centered-card>
    </div>
</div>
</template>

<script>


    import Logo from './layout/CenterLogo.vue';
    import CenteredCard from "./layout/CenteredCard";
    import TermsConditions from "./layout/TermsConditions";

    export default {
        name: 'TermsPage',
        data(){
            return {

            }
        },

        methods: {
          back() {
            window.history.back();
          }
        },
        components:{
            TermsConditions,
            CenteredCard,
            Logo
        }

    }
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/components/TermsPage.vue